export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/chevron-right-white.png?56e86e127cf2dd6457b56e621ab05124";